module.exports = __webpack_public_path__ + "static/media/BD.4ff5bf43.svg";